import React, { useState, useEffect } from 'react';
// import logo from '../../../assets/users/helene-engels.png'
import Input from '../../../../components/Form/Input'
import ImagePicker from '../../../../components/ImagePicker'
// import Select from '../../../../components/Form/Select'
import TextAreaEditor  from "../../../../components/Form/TextAreaEditor"
import ImageWithFallback from '../../../components/ImageWithFallback'
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import ButtonBlack from '../../../../components/Buttons/ButtonBlack';
import MultiSelect from '../../../../components/Form/Select/MultiSelect'
import {IMAGE_PATH} from "../../../../utils/constant"
import {districtDatas, regionDatas} from '../../../datas/RegionDistrict'
import { api } from '../../../../../api'
import { updateUser } from "../../../../redux/userSlice";
// D:\stage 2024\MIRA2.0\front\src\app\plateform\.js

 const CompanyProfile = ({ option }) => {
    const { user } = useSelector((store) => store.user);
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState({
        load: false,
        sectionUpdated: 0
    })
    const [logo, setLogo] = useState(user.organisation_profile?.logo || '/path/to/default/logo.png');
    const [newLogo, setNewLogo] = useState("");
      const {showNotif, setShowNotif} = useOutletContext()
      const [details, setDetails] = useState({
        name: user.organisation_profile?.company_name || '',
        sector: user.organisation_profile?.category_name || '',
        foundationDate: user.organisation_profile?.build_at || '',
        website: user.organisation_profile?.website_url || '',
        size: user.organisation_profile?.total_emloyees || '',
        slogan: user.organisation_profile?.slogan || '',
        description: user.organisation_profile?.description || ''
    })
    const [location, setLocation] = useState({
        address: user.organisation_profile?.address || '',
        region: user.region_district?.region || '',
        district: user.region_district?.district || ''
    })
    const [socialMedia, setSocialMedia] = useState({
        facebook: user.organisation_profile?.facebook_url || '',
        linkedin: user.organisation_profile?.linkedin_url || '',
        twitter: user.organisation_profile?.twitter_url || ''
    });

    const handleLogoChange = async () => {
        // setLogo(newLogo);
        setIsLoading({...isLoading, sectionUpdated: "logo", load: true})
        console.log(newLogo)
        const formData = new FormData();
        formData.append('logo', newLogo);
        await axios.post(`${api}/organisation-profile/${user.id}/update-logo`, formData)
            .then((response)=>{
                console.log(response.data)
                if(response.data?.user)dispatch(updateUser(response.data?.user));
                setIsLoading({...isLoading, sectionUpdated: "", load: false})
                setShowNotif({...showNotif, variant: "success", message:"Mise à jour réussie !", show: true})
            })
            .catch(error =>{
                setIsLoading({...isLoading, sectionUpdated: "", load: false})
                console.error('Error updating logo:', error)});
    };

    const handleDetailsChange = (field, value) => {
        setDetails(prev => ({ ...prev, [field]: value }));
    }

    const handleLocationChange = (field, value) => {
        setLocation(prev => ({ ...prev, [field]: value }));
    }

    const handleSocialMediaChange = (platform, value) => {
        setSocialMedia(prev => ({ ...prev, [platform]: value }));
    }

    const handleSubmit = async (section) => {
        const data = (section === 'details') ? details : (section === 'location') ? location : socialMedia;
        setIsLoading({...isLoading, sectionUpdated: section, load: true})
        // console.log("Section: ",section," , Data to send", data, user)
        await axios.post(`${api}/organisation-profile/${user.id}/update-${section}`, data)
            .then((response)=>{
                console.log(response.data)
                if(response.data?.user)dispatch(updateUser(response.data?.user));
                setIsLoading({...isLoading, sectionUpdated: "", load: false})
                setShowNotif({...showNotif, variant: "success", message:"Mise à jour réussie !", show: true})
            })
            .catch(error => {
                console.error(`Error updating ${section}:`, error)
                setIsLoading({...isLoading, sectionUpdated: "", load: false})
                setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
        })
    }

    return (
        option === 1 && (
            <>
                <div className="grid grid-cols-5 gap-4 py-6">
                    <div className="col-span-2">
                        <h2 className="font-semibold">Votre logo</h2>
                        <p>Mettez à jour votre logo.</p>
                    </div>
                    <div className="col-span-3  ">
                        <div className="flex gap-4 mb-4">
                            <ImageWithFallback src={IMAGE_PATH + logo} alt="company logo" className="w-28 h-28 rounded-full object-cover border" />
                            <ImagePicker handleImage={(e)=>setNewLogo(e.target.files[0])} />    
                        </div>
                        { newLogo && <div className="w-full flex justify-end">
                            <ButtonBlack isLoading={isLoading.load && isLoading?.sectionUpdated === "logo"}  onClick={()=>handleLogoChange()}>Enregistrer</ButtonBlack>
                       
                        </div>}
                                             
                    </div>
                    
                </div>
                
                <div className="grid grid-cols-5 gap-4 py-6">
                    <div className="col-span-2">
                        <h2 className="font-semibold">Détails de l'entreprise</h2>
                    </div>
                    <div className="col-span-3 space-y-4">                     
                        <Input label="Nom de votre entreprise" value={details.name} onChange={(e) => handleDetailsChange('name', e.target.value)} />
                         {/* <Select label="Secteur d'activité" options={[]} value={details.sector} onChange={(value) => handleDetailsChange('sector', value)} /> */}
                         <MultiSelect 
                            label="Secteur d'activité" 
                            options={[
                                { label: "Informatique & Technologie", value: "it" },
                                { label: "Santé & Médecine", value: "healthcare" },
                                { label: "Finance & Assurance", value: "finance" },
                                { label: "Commerce & Distribution", value: "commerce" },
                                { label: "Éducation & Formation", value: "education" },
                                { label: "Industrie & Production", value: "industry" },
                                { label: "Bâtiment & Travaux publics", value: "construction" },
                                { label: "Transport & Logistique", value: "transport" },
                                { label: "Hôtellerie & Tourisme", value: "hospitality" },
                                { label: "Marketing & Communication", value: "marketing" },
                                { label: "Énergie & Environnement", value: "energy" },
                                { label: "Droit & Juridique", value: "law" },
                                { label: "Arts, Culture & Divertissement", value: "arts" },
                                { label: "Autre", value: "other" }
                            ]}
                            value={details.sector} 
                            onChange={(value) => handleDetailsChange('sector', value)} 
                            />
                         <Input type="date" label="Date de fondation" value={details.foundationDate} onChange={(e) => handleDetailsChange('foundationDate', e.target.value)} />
                         <Input label="Site web" value={details.website} onChange={(e) => handleDetailsChange('website', e.target.value)} />
                         {/* <Select label="Taille de l'entreprise" options={[]} value={details.size} onChange={(value) => handleDetailsChange('size', value)} /> */}
                         <MultiSelect 
                            label="Taille de l'entreprise" 
                            options={[
                                { label: "Petite entreprise (1-50 employés)", value: "petite" },
                                { label: "Moyenne entreprise (51-250 employés)", value: "moyenne" },
                                { label: "Grande entreprise (250+ employés)", value: "grande" }
                            ]}
                            value={details.size} 
                            onChange={(value) => handleDetailsChange('size', value)} 
                        />

                         <TextAreaEditor label="Slogan" value={details.slogan} setValue={(value) => handleDetailsChange('slogan', value)} />
                         <TextAreaEditor label="Description" value={details.description} setValue={(value) => handleDetailsChange('description', value)} />
                         <div className="w-full flex justify-end">
                            <ButtonBlack isLoading={isLoading.load && isLoading?.sectionUpdated === "details"} onClick={() => handleSubmit('details')} >Modifier</ButtonBlack>
                            </div>
                            </div>
                </div>
                
                <div className="grid grid-cols-5 gap-4 py-6">
                    <div className="col-span-2">
                        <h2 className="font-semibold">Localisation</h2>
                    </div>
                    <div className="col-span-3 space-y-4">
                        <Input label="Adresse" value={location.address} onChange={(e) => handleLocationChange('address', e.target.value)} />
                        <div className="relative mb-6">
                <label htmlFor="region" className="block text-sm font-medium text-gray-700 text-start">Région</label>
                <div className="relative mt-1">
                    <select
                        id="region"
                        name="region"
                        value={location.region}
                        onChange={(e) => handleLocationChange('region', e.target.value)}
                        className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        required
                    >
                        <option value="">Choisissez une région</option>
                        {regionDatas.map((item, index) => (
                            <option key={index} value={item}>{item}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="relative mb-6">
                <label htmlFor="district" className="block text-sm font-medium text-gray-700 text-start">District</label>
                <div className="relative mt-1">
                    <select
                        id="district"
                        name="district"
                        value={location.district}
                        onChange={(e) => handleLocationChange('district', e.target.value)}
                        className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                        required
                    >
                        <option value="">Choisissez un district</option>
                        {location.region && districtDatas[location.region].map((item, index) => (
                            <option key={index} value={item}>{item}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="w-full flex justify-end">
                        <ButtonBlack isLoading={isLoading.load && isLoading?.sectionUpdated === "location"} onClick={() => handleSubmit('location')} >Modifier</ButtonBlack>
                        </div>
                        </div>
                </div>
                
                <div className="grid grid-cols-5 gap-4 py-6">
                    <div className="col-span-2">
                        <h2 className="font-semibold">Réseaux sociaux</h2>
                    </div>
                    <div className="col-span-3 space-y-4">
                        {Object.keys(socialMedia).map((platform) => (
                            <div key={platform} className="flex border rounded-md divide-x">
                                <div className="p-2">www.{platform}.com/</div>
                                <input className="p-2 w-full outline-none" value={socialMedia[platform]} onChange={(e) => handleSocialMediaChange(platform, e.target.value)} />
                            </div>
                        ))}
                         <div className="w-full flex justify-end">
                        <ButtonBlack isLoading={isLoading.load && isLoading?.sectionUpdated === "socialMedia"} onClick={() => handleSubmit('socialMedia')} >Modifier</ButtonBlack>
                    </div>
                    </div>
                </div>
            </>
        )
    );
};

export default CompanyProfile;

// const CompanyProfile = ({ option }) => {
//     const [logo, setLogo] = useState('/path/to/default/logo.png')
//     const { user } = useSelector((store) => store.user)
//     const [details, setDetails] = useState({
//         name: '',
//         sector: '',
//         foundationDate: '',
//         website: '',
//         size: '',
//         slogan: '',
//         description: ''
//     });
//     const [location, setLocation] = useState({
//         address: '',
//         region: '',
//         district: ''
//     });
//     const [socialMedia, setSocialMedia] = useState({
//         facebook: 'johndoe',
//         linkedin: 'johndoe',
//         twitter: 'johndoe'
//     });

//     // Handlers for updating each section
//     const handleLogoChange = (newLogo) => setLogo(newLogo);
    
//     const handleDetailsChange = (field, value) => {
//         setDetails(prevDetails => ({ ...prevDetails, [field]: value }));
//     };

//     const handleLocationChange = (field, value) => {
//         setLocation(prevLocation => ({ ...prevLocation, [field]: value }));
//     };

//     const handleSocialMediaChange = (platform, value) => {
//         setSocialMedia(prevSocialMedia => ({ ...prevSocialMedia, [platform]: value }));
//     };

//     const handleSubmit = (section) => {
//         // Add logic to handle form submission based on section
//         // E.g., save updated data to the server or state management
//         console.log(`Saving ${section}...`);
//     };

//     return (
//         option === 1 && (
//             <>
//                 {/* Change Logo Section */}
//                 <div className="grid grid-cols-5 gap-4 py-6">
//                     <div className="text-sm text-start space-y-2 col-span-2">
//                         <h2 className="font-semibold text-sm">Votre logo</h2>
//                         <p className="text-sm text-primary-text">
//                             Mettez à jour votre logo pour renforcer la visibilité de votre compte.
//                         </p>
//                     </div>
//                     <div className="flex items-center justify-center col-span-3 gap-x-4">
//                         <ImageWithFallback src={logo} alt="company logo" className="w-28 h-28  rounded-full shadow-sm object-cover bg-center opacity-90" defaultType='logo'/>
//                         <ImagePicker onChange={handleLogoChange} />
//                     </div>
//                 </div>

//                 {/* Company Details Section */}
//                 <div className="grid grid-cols-5 gap-4 py-6">
//                     <div className="text-sm text-start space-y-2 col-span-2">
//                         <h2 className="font-semibold text-sm">Sécurité du compte</h2>
//                         <p className="text-sm text-primary-text">
//                             Mettez à jour les informations de votre entreprise.
//                         </p>
//                     </div>
//                     <div className="col-span-3 space-y-4">
//                         <Input label="Nom de votre entreprise" value={details.name} onChange={(e) => handleDetailsChange('name', e.target.value)} />
//                         <Select label="Secteur d'activité" value={details.sector} onChange={(value) => handleDetailsChange('sector', value)} />
//                         <Input type="date" label="Date de fondation" value={details.foundationDate} onChange={(e) => handleDetailsChange('foundationDate', e.target.value)} />
//                         <Input label="Site web" value={details.website} onChange={(e) => handleDetailsChange('website', e.target.value)} />
//                         <Select label="Taille de l'entreprise" value={details.size} onChange={(value) => handleDetailsChange('size', value)} />
//                         <TextAreaEditor label="Slogan" value={details.slogan} onChange={(value) => handleDetailsChange('slogan', value)} />
//                         <TextAreaEditor label="Description" value={details.description} onChange={(value) => handleDetailsChange('description', value)} />
//                         <div className="flex justify-end my-4">
//                             <button onClick={() => handleSubmit('details')} className="text-xs px-6 py-2.5 rounded-md bg-primary-black text-white">
//                                 Modifier
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Location Section */}
//                 <div className="grid grid-cols-5 gap-4 py-6">
//                     <div className="text-sm text-start space-y-2 col-span-2">
//                         <h2 className="font-semibold text-sm">Localisation</h2>
//                         <p className="text-sm text-primary-text">
//                             Mettez à jour l'adresse de votre entreprise.
//                         </p>
//                     </div>
//                     <div className="col-span-3 space-y-4">
//                         <Input label="Adresse" value={location.address} onChange={(e) => handleLocationChange('address', e.target.value)} />
//                         <Select label="Région" value={location.region} onChange={(value) => handleLocationChange('region', value)} />
//                         <Select label="District" value={location.district} onChange={(value) => handleLocationChange('district', value)} />
//                         <div className="flex justify-end my-4">
//                             <button onClick={() => handleSubmit('location')} className="text-xs px-6 py-2.5 rounded-md bg-primary-black text-white">
//                                 Modifier
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Social Media Section */}
//                 <div className="grid grid-cols-5 gap-4 py-6">
//                     <div className="text-sm text-start space-y-2 col-span-2">
//                         <h2 className="font-semibold text-sm">Réseaux sociaux</h2>
//                         <p className="text-sm text-primary-text">
//                             Mettez à jour les liens de vos réseaux sociaux.
//                         </p>
//                     </div>
//                     <div className="col-span-3 space-y-4 text-sm">
//                         {['facebook', 'linkedin', 'twitter'].map((platform) => (
//                             <div key={platform} className="flex border rounded-md divide-x">
//                                 <div className="text-primary-black p-2">www.{platform}.com/</div>
//                                 <input
//                                     name={`${platform}-url`}
//                                     className="text-primary-text outline-none p-2"
//                                     value={socialMedia[platform]}
//                                     onChange={(e) => handleSocialMediaChange(platform, e.target.value)}
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </>
//         )
//     );
// };

// export default CompanyProfile;
